import { combineReducers } from "redux";

import order from "./order_reducer";
import app from "./app_reducer";

const rootReducer = combineReducers({ order, app });

export default rootReducer;
